import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { isEmpty, map } from 'lodash';
import turf from '@turf/turf';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import { emailRegex } from '../../../modules/regex-utils';
import * as atlasOps from '../../../api/Atlas/atlas-operations';
import Validation from '../../containers/Validation';

import Styles from './styles';

class DatasetStepOne extends Component {
  state = {
    showModal: false,
    JsonList: []
  };

  async componentDidMount() {
    const { JsonList } = this.state;
    const { gmsConnection } = this.props;
    if (isEmpty(JsonList)) {
      const url = `http://${atlasOps.getGMSDirection(
        gmsConnection
      )}/MG/utilities/json_read_for_front`;
      const ftpParameters = await methodPromise('tasks.getTaskFTPParameters');
      const data = {
        path_json: 'landing_ipsgeoprocesing/files/json_config',
        ...ftpParameters
      };
      const list = await methodPromise('tasks.getListJson', { data, url });
      this.setState({ JsonList: list });
    }
  }

  handleSubmit = async form => {
    try {
      const { gmsConnection, aiInterestArea } = this.props;

      if (isEmpty(aiInterestArea)) throw new Error('Empty interest area');
      const bbox = `[${turf.bbox(aiInterestArea)}]`;
      const ftpParameters = await methodPromise('tasks.getTaskFTPParameters');
      const emails = map(form.emailAddress.value.split(/[;,]+/), email => email.trim());
      const emailsForTask = emails.join(' ');
      const Configurations = map(form.JsonConfig.value.split(/[;,]+/), config => config.trim());
      const config = Configurations.join('');
      const name = form.alias.value.trim();
      const url = `http://${atlasOps.getGMSDirection(gmsConnection)}/MG/dataset/exec_dataset`;
      const emptyProb = form.empty_prob.value.trim();
      const zoom = form.zoom.value.trim();
      const maxSize = form.max_size.value.trim();
      const minSize = form.min_size.value.trim();
      const data = {
        input_aoi: bbox,
        json_config: config,
        output_url: name,
        send_to: emailsForTask,
        http_port: '4444',
        size_filters: emptyProb,
        zoom,
        max_size: maxSize,
        min_size: minSize,
        ...ftpParameters
      };

      this.setState({ showModal: false });
      await methodPromise('tasks.getDataset', { data, url });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  openModal = () => this.setState({ showModal: true });

  closeModal = () => this.setState({ showModal: false });

  render() {
    const { isPreview, isPublic } = this.props;
    const { showModal, JsonList } = this.state;

    const validationProps = {
      rules: {
        alias: {
          required: true
        },
        emailAddress: {
          required: true,
          multiemails: emailRegex
        },
        zoom: {
          required: true
        },
        empty_prob: {
          required: true
        },
        max_size: {
          required: true,
          min: 0,
          max: 2000
        },
        min_size: {
          required: true,
          min: 0,
          max: 2000
        }
      },
      messages: {
        alias: {
          required: "What's the task alias?"
        },
        emailAddress: {
          required: 'Need an email address here.',
          multiemails: 'Are all these email addresses correct?'
        }
      },
      submitHandler: form => {
        this.handleSubmit(form);
      }
    };

    return (
      <Styles.AITaskConfigurationContainer>
        <Modal show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Introduce your data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Validation {...validationProps}>
              <Form onSubmit={event => event.preventDefault()}>
                <Form.Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Alias</Form.Label>
                    <Form.Control type="text" name="alias" defaultValue="" />
                  </Form.Group>

                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Email Addresses</Form.Label>
                    <Form.Control type="text" name="emailAddress" defaultValue="" />
                  </Form.Group>
                </Form.Row>
                <Form.Group>
                  <Form.Label>Configuration</Form.Label>
                  <Form.Control as="select" name="JsonConfig" id="JsonConfig">
                    <option value="">-</option>
                    {map(JsonList, ({ nombre, path }) => {
                      return (
                        <option value={path} key={path}>
                          {nombre}
                        </option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>

                <Form.Row>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Zoom</Form.Label>
                    <Form.Control type="text" name="zoom" defaultValue="100,200" />
                  </Form.Group>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Size Filters</Form.Label>
                    <Form.Control type="text" name="empty_prob" defaultValue="0.0005, 0.60, 3600" />
                  </Form.Group>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Max Size</Form.Label>
                    <Form.Control
                      type="number"
                      name="max_size"
                      step={1}
                      min={0}
                      max={2000}
                      defaultValue={512}
                    />
                  </Form.Group>
                  <Form.Group as={Col} xs={12}>
                    <Form.Label>Min Size</Form.Label>
                    <Form.Control
                      type="number"
                      name="min_size"
                      step={1}
                      min={0}
                      max={2000}
                      defaultValue={512}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Col xs={{ span: 4, offset: 4 }} className="pt-3">
                    <Button block type="submit" variant="success">
                      Run Detection
                    </Button>
                  </Col>
                </Form.Row>
              </Form>
            </Validation>
          </Modal.Body>
        </Modal>
        <Form.Row>
          <Form.Label column="lg" xs={12} className="mb-0 mx-1 px-3">
            Create DataSet
          </Form.Label>
        </Form.Row>
        <Row className="mb-3 pb-3">
          <Col
            xs={{ span: 4, offset: 4 }}
            sm={{ span: isPublic ? 4 : 6, offset: isPublic ? 4 : 3 }}
            md={{ span: isPublic ? 8 : 10, offset: isPublic ? 2 : 1 }}
            lg={{ span: isPublic ? 6 : 8, offset: isPublic ? 3 : 2 }}
            xl={{ span: 6, offset: 3 }}
          >
            <Button block disabled={isPreview} variant="outline-primary" onClick={this.openModal}>
              Configuration
            </Button>
          </Col>
        </Row>
      </Styles.AITaskConfigurationContainer>
    );
  }
}

DatasetStepOne.propTypes = {
  aiInterestArea: PropTypes.object.isRequired,
  atlas: PropTypes.object.isRequired,
  gmsConnection: PropTypes.object.isRequired,
  isPreview: PropTypes.bool.isRequired,
  isPublic: PropTypes.bool.isRequired
};

export default DatasetStepOne;
